var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardLogoMastercard = function SvgCardLogoMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 38,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 36.33,
    x: 0.5,
    y: 0.5,
    fill: "#F9F9FA",
    rx: 5.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 36.33,
    x: 0.5,
    y: 0.5,
    stroke: "#DFE0E5",
    rx: 5.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED0006",
    d: "M35.015 7.917c5.974 0 10.817 4.812 10.817 10.748s-4.843 10.748-10.817 10.748A10.8 10.8 0 0 1 28 26.842a10.8 10.8 0 0 1-7.016 2.571c-5.973 0-10.815-4.812-10.815-10.748S15.01 7.917 20.984 7.917c2.678 0 5.127.969 7.016 2.57a10.8 10.8 0 0 1 7.015-2.57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9A000",
    d: "M35.016 7.917c5.973 0 10.815 4.812 10.815 10.748S40.99 29.413 35.016 29.413A10.8 10.8 0 0 1 28 26.842a10.7 10.7 0 0 0 3.8-8.177c0-3.275-1.475-6.206-3.8-8.178a10.8 10.8 0 0 1 7.016-2.57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5E00",
    d: "M28 10.488c2.324 1.972 3.8 4.902 3.8 8.177s-1.476 6.204-3.8 8.176a10.694 10.694 0 0 1 0-16.352"
  })));
};
export default SvgCardLogoMastercard;